export const config = {
  title: "New Customer",
  company_logo: "hennessy.png",
  logo_placements: ["Left Chest", "Right Sleeve"],
  show_image_preview: true,
  embroideries: {
    hat: [
      "Cadillac",
      "Hennessy Ford",
      "Hennessy Ford Lincoln",
      "Hennessy Honda",
      "Hennessy Mazda GMC",
      "Hennessy Porsche",
      "Porsche",
      "Porsche Atlanta NW",
      "Porsche North Atl",
    ],
    mens: [
      "Cadillac",
      "Hennessy Ford",
      "Hennessy Ford Lincoln",
      "Hennessy Honda",
      "Hennessy Mazda GMC",
      "Hennessy Porsche",
      "Porsche",
      "Porsche Atlanta NW",
      "Porsche North Atl",
    ],
    womens: [
      "Cadillac",
      "Hennessy Ford",
      "Hennessy Ford Lincoln",
      "Hennessy Honda",
      "Hennessy Mazda GMC",
      "Hennessy Porsche",
      "Porsche",
      "Porsche Atlanta NW",
      "Porsche North Atl",
    ],
    accessory: [
      "Cadillac",
      "Hennessy Ford",
      "Hennessy Ford Lincoln",
      "Hennessy Honda",
      "Hennessy Mazda GMC",
      "Hennessy Porsche",
      "Porsche",
      "Porsche Atlanta NW",
      "Porsche North Atl",
    ],
    customs: [],
    office: [],
  },
  stores: {
    "Pohanka Hyundai , 2015 N Salisbury, Salisbury, MD 21801": "POHHSA",
  },
  bypass_codes: [],
  server_hostname: "https://mxfj3q6m01.execute-api.us-east-1.amazonaws.com",
  account_reps: [
    { name: "Andrew Sarazua", phone: "678-287-1604" },
    { name: "John Boston", phone: "678-287-1601" },
  ],
};
